import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import Link from "next/link";
import type { MenuItemType } from "@/types/menu";
import { InfoBlock } from "./InfoBlock";
import { cn } from "@/lib/utils";
import { FeatureImageItem } from "./FeatureImageItem";

export const MobileMenuItem = ({ item }: { item: MenuItemType }) => {

  if (item.hasSubmenu && item.subMenu && ((item.subMenu.hasLeftColItems && item.subMenu.leftColItems?.items && item.subMenu.leftColItems.items.length > 0) || (item.subMenu.hasRightColItems && item.subMenu.rightColItems?.items && item.subMenu.rightColItems.items.length > 0))) {
    return (
      <AccordionItem key={item.label} value={item.label || ""}>
        <AccordionTrigger className="!no-underline paragraph-lg font-bold text-primary px-6 bg-background dark:bg-muted" iconLg={true}>{item.label}</AccordionTrigger>
        <AccordionContent className="px-6 pb-6 border-t bg-muted">
          {item.subMenu.infoBlock && (
            <div className="pt-6 mb-8">
              <InfoBlock item={item.subMenu.infoBlock} />
            </div>
          )}
          <div className="flex flex-col gap-2">
            {item.subMenu.leftColItems?.label && (
              <div className="paragraph-sm font-medium text-muted-foreground py-2">{item.subMenu.leftColItems?.label}</div>
            )}
            {item.subMenu?.leftColItems?.items?.map((m) => (
              item.subMenu?.leftColItems?.displayStyle === "Feature Image Item" ? (
                <FeatureImageItem key={m.title} items={item.subMenu?.leftColItems} />
              ) : (
                (m.title && m.link) && (
                  <Link key={m.title} href={m.link || '#'} className={cn(
                    "py-2 block no-underline paragraph-base",
                    m.bold && "font-bold"
                  )} prefetch={false}>
                    <span className="flex flex-row items-center gap-2">
                      {m.title}
                      {m?.hasSuffixIcon && m?.suffixIcon && (
                          <span className="material-symbols-outlined !text-[20px] text-muted-foreground">
                            {m.suffixIcon}
                          </span>
                        )}
                      </span>
                  </Link>
                )
              )
            ))}
            {item.subMenu.rightColItems?.label && (
              <div className="paragraph-sm font-medium text-muted-foreground py-2 mt-6">{item.subMenu.rightColItems?.label}</div>
            )}
            {item.subMenu.rightColItems?.items?.map((m) => (
              item.subMenu?.rightColItems?.displayStyle === "Feature Image Item" ? (
                <FeatureImageItem key={m.title} items={item.subMenu?.rightColItems} className="mt-8"/>
              ) : (
                (m.title && m.link) && (
                  <Link key={m.title} href={m.link || '#'} className={cn(
                    "py-2 block no-underline paragraph-base", 
                    m.bold && "font-bold"
                  )} prefetch={false}>
                    <span className="flex flex-row items-center gap-2">
                      {m.title}
                      {m?.hasSuffixIcon && m?.suffixIcon && (
                        <span className="material-symbols-outlined !text-[20px] text-muted-foreground">
                          {m.suffixIcon}
                        </span>
                      )}
                    </span>
                  </Link>
                )
              )
            ))}
          </div>
          
        </AccordionContent>
      </AccordionItem>
    );
  }
  
  if(item.label && item.link) {
    return (
      <Link href={item.link || '#'} className="block py-2 paragraph-base" prefetch={false}>
        {item.label}
      </Link>
    );
  }

  return null;
};

MobileMenuItem.displayName = 'NavMobileMenuItem'; 